import { Component, Inject, Optional } from "@angular/core";
import { SETTINGS_CONFIG_DATA } from "../../controller-selector.component";
import { ensureOptionsExist } from "../../../../../../../../../gis/models/gis-config.model";
import { WellConfigurationData, GisContextLocationType } from "../../../../../../../../../form-controls/components/new-casing-plan/models/casing-plan.model"


@Component({
    selector: "app-gis-settings",
    templateUrl: "./gis-settings.component.html",
    styleUrls: ["./gis-settings.component.scss"],
    standalone: false
})
export class GISSettingsComponent {

    get locationWriteOptions(): WellConfigurationData[] {
        return this.data.arguments.writeContextOptions.filter(o => o.locationType === GisContextLocationType.LocationWrite);
    }

    get conditionWriteOptions(): WellConfigurationData[] {
        return this.data.arguments.writeContextOptions.filter(o => o.locationType === GisContextLocationType.ConditionWrite);
    }

    constructor(@Optional() @Inject(SETTINGS_CONFIG_DATA) public data: { controllerName: string, arguments: any }) {        
        if (data) {
            data.arguments = ensureOptionsExist(data.arguments);
        }
    }
}
